import { useRef } from 'react'
import { Subtitle, TextareaField } from 'src/components'
import { useDecrypt, useEncrypt } from '../../queries'
import { useCryptoReducer } from '../hooks'

const debounce = require('lodash.debounce')

export default function AdminServerCrypto() {
  const [state, dispatch] = useCryptoReducer()

  const encrypt = useEncrypt()
  const decrypt = useDecrypt()

  const encryptWithDebounce = useRef(
    debounce((value: string) => {
      const text = value.trim()
      if (text) {
        encrypt
          .mutateAsync({ text })
          .then((decrypt) =>
            dispatch({ type: 'SET_ENCRYPT_RESULT', payload: { decrypt } }),
          )
      } else {
        dispatch({ type: 'SET_ENCRYPT_RESULT', payload: { decrypt: '' } })
      }
    }, 250),
  ).current

  const decryptWithDebounce = useRef(
    debounce((value: string) => {
      const text = value.trim()
      if (text) {
        decrypt
          .mutateAsync({ text })
          .then((encrypt) =>
            encrypt
              ? dispatch({ type: 'SET_DECRYPT_RESULT', payload: { encrypt } })
              : dispatch({ type: 'SET_DECRYPT_ERROR' }),
          )
          .catch(() => {
            dispatch({ type: 'SET_DECRYPT_ERROR' })
          })
      } else {
        dispatch({ type: 'SET_DECRYPT_RESULT', payload: { encrypt: '' } })
      }
    }, 250),
  ).current

  const encryptChange = (value: string) => {
    dispatch({
      type: 'SET_ENCRYPT_VALUE',
      payload: { encrypt: value },
    })
    encryptWithDebounce(value)
  }

  const decryptChange = (value: string) => {
    dispatch({
      type: 'SET_DECRYPT_VALUE',
      payload: {
        decrypt: value,
      },
    })
    decryptWithDebounce(value)
  }

  return (
    <>
      <Subtitle label="Crypto Server" />
      <div className="grid grid-cols-2 gap-6">
        <TextareaField
          label="encrypt"
          classNameInput="h-32"
          value={state.encrypt}
          onChange={encryptChange}
          enabledCopy
          error={state.encryptError}
        />
        <TextareaField
          label="decrypt"
          classNameInput="h-32"
          value={state.decrypt}
          onChange={decryptChange}
          enabledCopy
          error={state.decryptError}
        />
      </div>
    </>
  )
}
